import React from "react";
import { Box, Grid } from "@mui/material";
import { Controller as Fc } from "react-hook-form";
import { useSnackbarContext } from "src/context/SnackbarContext";
import { useTranslation } from "react-i18next";

const QuestionMultipleChoiceManyAnswer = ({
  setValue,
  control,
  item,
  customStyle,
}) => {
  const { showSnackbar } = useSnackbarContext();
  const { t } = useTranslation();
  return (
    <Grid container spacing={"10px"}>
      {item.choices.length > 0 &&
        item.choices.map((ch, chKey) => (
          <Grid item xs={12} md={12} key={chKey}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Fc
                name={`answer[_${item.id}]`}
                control={control}
                render={({ field }) => {
                  return (
                    <>
                      <input
                        {...field}
                        checked={
                          field?.value ? field?.value?.includes(ch.id) : false
                        }
                        value={field?.value ? JSON.stringify(field?.value) : ""}
                        type="checkbox"
                        id={`flexCheckDefault45345${ch.id}`}
                        style={{
                          width: "20px",
                          height: "20px",
                          accentColor:
                            customStyle?.accentColor ?? "var(--color-black)",
                        }}
                        className="custom-radio"
                        onChange={(event) => {
                          let valueForMultipleAnswer = field?.value
                            ? [...field.value]
                            : [];

                          if (event.target.checked) {
                            // Check if item is already selected
                            const isAlreadySelected =
                              valueForMultipleAnswer.includes(ch.id);

                            if (!isAlreadySelected) {
                              // Get the limit value, default to unlimited if not set
                              const limit = item.limits
                                ? parseInt(item.limits)
                                : null;

                              // Only enforce limit if it's set and greater than 0
                              if (
                                limit !== null &&
                                limit > 0 &&
                                valueForMultipleAnswer.length >= limit
                              ) {
                                // Prevent checking and show error
                                event.target.checked = false;
                                showSnackbar(
                                  t(
                                    "individual.booking.schedule.warning.survey_pick_limit",
                                    {
                                      limits: limit,
                                    }
                                  ),
                                  "error"
                                );
                                return;
                              }

                              // Add the item
                              valueForMultipleAnswer.push(ch.id);
                            }
                            // If already selected, do nothing (shouldn't happen, but safe)
                          } else {
                            // Remove the item when unchecked
                            valueForMultipleAnswer =
                              valueForMultipleAnswer.filter((x) => x !== ch.id);
                          }

                          setValue(
                            `answer[_${item.id}]`,
                            valueForMultipleAnswer
                          );
                        }}
                      />

                      <label
                        htmlFor={`flexCheckDefault45345${ch.id}`}
                        style={{
                          marginTop: "5px",
                          marginLeft: "5px",
                          cursor: "pointer",
                          textTransform: "capitalize",
                          fontWeight: 400,
                          fontSize: "14px",
                          lineHeight: "24px",
                          fontFamily: `var(--font-${customStyle?.bodyFont})`,
                          color: customStyle?.textColor ?? "#19181B",
                        }}
                      >
                        {ch.options}
                      </label>
                    </>
                  );
                }}
              />
            </Box>
          </Grid>
        ))}
    </Grid>
  );
};

export default QuestionMultipleChoiceManyAnswer;
